export default {"frames": [

{
	"filename": "C.png",
	"frame": {"x":788,"y":1405,"w":117,"h":144},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":69,"y":56,"w":117,"h":144},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "D.png",
	"frame": {"x":300,"y":1184,"w":126,"h":140},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":65,"y":58,"w":126,"h":140},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "E.png",
	"frame": {"x":907,"y":1472,"w":116,"h":135},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":70,"y":60,"w":116,"h":135},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "J.png",
	"frame": {"x":576,"y":1170,"w":123,"h":136},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":66,"y":60,"w":123,"h":136},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "M.png",
	"frame": {"x":447,"y":935,"w":133,"h":138},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":61,"y":59,"w":133,"h":138},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "O.png",
	"frame": {"x":549,"y":1308,"w":118,"h":139},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":69,"y":58,"w":118,"h":139},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "Ob.png",
	"frame": {"x":703,"y":1113,"w":123,"h":142},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":66,"y":57,"w":123,"h":142},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "Oc.png",
	"frame": {"x":428,"y":1215,"w":119,"h":141},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":68,"y":57,"w":119,"h":141},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "P.png",
	"frame": {"x":788,"y":1551,"w":117,"h":134},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":69,"y":61,"w":117,"h":134},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "planet_1.png",
	"frame": {"x":828,"y":1255,"w":88,"h":82},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":20,"y":23,"w":88,"h":82},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "planet_2.png",
	"frame": {"x":756,"y":471,"w":199,"h":218},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":27,"y":17,"w":199,"h":218},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "planet_3.png",
	"frame": {"x":920,"y":1132,"w":99,"h":88},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":11,"y":21,"w":99,"h":88},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "planet_4.png",
	"frame": {"x":712,"y":997,"w":125,"h":114},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":7,"w":125,"h":114},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "planet_5.png",
	"frame": {"x":918,"y":1372,"w":105,"h":98},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":12,"y":15,"w":105,"h":98},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "planet_6.png",
	"frame": {"x":922,"y":919,"w":101,"h":102},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":13,"y":13,"w":101,"h":102},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "planet_7.png",
	"frame": {"x":1,"y":1449,"w":106,"h":111},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":11,"y":9,"w":106,"h":111},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "R.png",
	"frame": {"x":701,"y":1257,"w":122,"h":134},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":67,"y":61,"w":122,"h":134},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "space-face-1.png",
	"frame": {"x":1,"y":1,"w":753,"h":932},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":166,"y":13,"w":753,"h":932},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "space-face-2.png",
	"frame": {"x":839,"y":997,"w":79,"h":256},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":31,"y":0,"w":79,"h":256},
	"sourceSize": {"w":128,"h":256}
},
{
	"filename": "space-face-3.png",
	"frame": {"x":300,"y":935,"w":145,"h":247},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":60,"y":6,"w":145,"h":247},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "space-face-4.png",
	"frame": {"x":756,"y":691,"w":193,"h":85},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":32,"y":21,"w":193,"h":85},
	"sourceSize": {"w":256,"h":128}
},
{
	"filename": "space-face-5.png",
	"frame": {"x":1,"y":1358,"w":110,"h":84},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":22,"w":110,"h":84},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "space-face-6.png",
	"frame": {"x":576,"y":1080,"w":125,"h":88},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":20,"w":125,"h":88},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "space-face-7.png",
	"frame": {"x":957,"y":554,"w":63,"h":32},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":63,"h":32},
	"sourceSize": {"w":64,"h":32}
},
{
	"filename": "space-face-8.png",
	"frame": {"x":1,"y":935,"w":297,"h":293},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":107,"y":109,"w":297,"h":293},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "space-face-9.png",
	"frame": {"x":969,"y":305,"w":41,"h":100},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":11,"y":14,"w":41,"h":100},
	"sourceSize": {"w":64,"h":128}
},
{
	"filename": "space-face-10.png",
	"frame": {"x":1,"y":1230,"w":86,"h":64},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":21,"y":0,"w":86,"h":64},
	"sourceSize": {"w":128,"h":64}
},
{
	"filename": "space-face-11.png",
	"frame": {"x":1,"y":1569,"w":86,"h":112},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":21,"y":8,"w":86,"h":112},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "space-face-12.png",
	"frame": {"x":1,"y":1713,"w":87,"h":151},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":20,"y":53,"w":87,"h":151},
	"sourceSize": {"w":128,"h":256}
},
{
	"filename": "space-face-13.png",
	"frame": {"x":969,"y":468,"w":32,"h":84},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":22,"w":32,"h":84},
	"sourceSize": {"w":32,"h":128}
},
{
	"filename": "space-face-14.png",
	"frame": {"x":825,"y":1339,"w":91,"h":64},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":0,"w":91,"h":64},
	"sourceSize": {"w":128,"h":64}
},
{
	"filename": "space-face-15.png",
	"frame": {"x":582,"y":935,"w":128,"h":143},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":56,"w":128,"h":143},
	"sourceSize": {"w":128,"h":256}
},
{
	"filename": "space-face-16.png",
	"frame": {"x":951,"y":691,"w":72,"h":124},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":28,"y":2,"w":72,"h":124},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "space-face-17.png",
	"frame": {"x":969,"y":407,"w":39,"h":59},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":12,"y":2,"w":39,"h":59},
	"sourceSize": {"w":64,"h":64}
},
{
	"filename": "space-face-18.png",
	"frame": {"x":756,"y":239,"w":211,"h":230},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":22,"y":13,"w":211,"h":230},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "space-face-19.png",
	"frame": {"x":669,"y":1393,"w":117,"h":174},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":41,"w":117,"h":174},
	"sourceSize": {"w":128,"h":256}
},
{
	"filename": "space-face-20.png",
	"frame": {"x":920,"y":1023,"w":99,"h":107},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":14,"y":10,"w":99,"h":107},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "space-face-21.png",
	"frame": {"x":969,"y":239,"w":43,"h":64},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":10,"y":0,"w":43,"h":64},
	"sourceSize": {"w":64,"h":64}
},
{
	"filename": "space-face-22.png",
	"frame": {"x":920,"y":1222,"w":97,"h":148},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":15,"y":54,"w":97,"h":148},
	"sourceSize": {"w":128,"h":256}
},
{
	"filename": "space-face-23.png",
	"frame": {"x":756,"y":919,"w":164,"h":76},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":46,"y":26,"w":164,"h":76},
	"sourceSize": {"w":256,"h":128}
},
{
	"filename": "space-face-24.png",
	"frame": {"x":756,"y":778,"w":191,"h":139},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":32,"y":58,"w":191,"h":139},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "space-face-25.png",
	"frame": {"x":957,"y":588,"w":58,"h":64},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":58,"h":64},
	"sourceSize": {"w":64,"h":64}
},
{
	"filename": "space-face-26.png",
	"frame": {"x":907,"y":1609,"w":112,"h":102},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":13,"w":112,"h":102},
	"sourceSize": {"w":128,"h":128}
},
{
	"filename": "space-face-27.png",
	"frame": {"x":756,"y":1,"w":235,"h":236},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":10,"y":10,"w":235,"h":236},
	"sourceSize": {"w":256,"h":256}
},
{
	"filename": "T.png",
	"frame": {"x":447,"y":1075,"w":127,"h":138},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":64,"y":59,"w":127,"h":138},
	"sourceSize": {"w":256,"h":256}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "space-face.png",
	"format": "RGBA8888",
	"size": {"w":1024,"h":2048},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:a080e5312e56caf36486a7e33688f9c6:5cf2da6c77260010e13140e9283011f8:2477fb2d51ffebe52e76ad700f3bcf16$"
}
}
